import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SettingsUtilsService {
  extractEmails(text: string): string[] | null {
    return text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g);
  }

  addEmails(
    emailList: string[],
    newEmails: string[],
    currentUserEmail: string,
    domain: string,
  ): { updatedList: string[]; error?: string } {
    const updatedList = [...emailList];
    for (const email of newEmails) {
      if (email === currentUserEmail) {
        return {
          updatedList,
          error: 'Provided email is already added to the recipients list.',
        };
      }
      if (email.split('@')[1] !== domain) {
        return {
          updatedList,
          error: `Provided email is outside of ${domain} domain.`,
        };
      }
      if (!updatedList.includes(email)) {
        updatedList.push(email);
      }
    }
    return { updatedList };
  }

  removeEmail(emailList: string[], emailToRemove: string): string[] {
    return emailList.filter((email) => email !== emailToRemove);
  }

  iMatch(entity) {
    if (entity?.matched_form) {
      return (
        entity?.name.charAt(0).toLowerCase() !== entity?.matched_form.charAt(0)
      );
    }
  }
  numberFormat(num: number) {
    if (num === undefined || num === null) {
      return '';
    }
    const formatter = new Intl.NumberFormat('en', { notation: 'compact' });
    return formatter.format(num);
  }
}
